// extracted by mini-css-extract-plugin
module.exports = {"notfoundID":"ErrorCatch__notfoundID__2kbWj","notfound":"ErrorCatch__notfound__HNF09","notfound_404":"ErrorCatch__notfound_404__1FIAq"};